import { render, staticRenderFns } from "./GrainTypeManage.vue?vue&type=template&id=2b5cd9b2&scoped=true"
import script from "./GrainTypeManage.vue?vue&type=script&lang=js"
export * from "./GrainTypeManage.vue?vue&type=script&lang=js"
import style0 from "./GrainTypeManage.vue?vue&type=style&index=0&id=2b5cd9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5cd9b2",
  null
  
)

export default component.exports